type TrueOrFalse = "TRUE" | "FALSE";

interface Props {
  status: boolean | undefined; // status 자체가 없으면은 안되고, optional type으로 넘겨주는 경우가 있기 때문에 undefined 값을 넣어줬습니다.
  caseBy: Record<TrueOrFalse, JSX.Element>;
}

/**
 * @name BooleanCase
 * @description boolean을 사용한 삼항 연산자 구문을 선언적으로 사용할 수 있는 컴포넌트입니다.
 *
 * @example
 * <BooleanCase
 *    status={isBoolean}
 *    caseBy={{
 *      TRUE: <div>if true</div>,
 *      FALSE: <div>if false</div>
 *    }}
 * />
 */

export const BooleanCase = ({ status, caseBy }: Props) => {
  if (status) return caseBy.TRUE;

  return caseBy.FALSE;
};
